"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import MainLayout from "@/app_views/MainLayout.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import ElPhoneVerifyCodeInput from "../framework/components/form/ElPhoneVerifyCodeInput.vue";
import Validator from "../framework/components/form/validator";
import Cookies from "js-cookie";
import API from "@ym-framework/api-utils";
import QrcodeVue from "qrcode.vue";
const Fingerprint2 = require("fingerprintjs2");
import md5 from "md5";
import { Base64 } from "js-base64";
let Register = class extends Vue {
  constructor() {
    super(...arguments);
    this.status = "ready";
    this.rules = {
      phone: [
        {
          required: true,
          message: this.$t("register.phone_trigger_tip"),
          trigger: "blur"
        },
        { validator: Validator.phone, trigger: "blur" }
      ],
      password: [
        {
          required: true,
          message: this.$t("register.password_trigger_tip"),
          trigger: "blur"
        },
        {
          min: 6,
          max: 24,
          message: this.$t("register.password_trigger_tip2"),
          trigger: "blur"
        },
        { validator: Validator.password, trigger: "blur" }
      ],
      verify_code: [
        {
          required: true,
          message: this.$t("register.verify_code_trigger_tip"),
          trigger: "blur"
        }
      ]
    };
    this.auth_images = [];
    this.isWeiXin = false;
    this.wxcode = null;
    this.formData = {
      query_param: null,
      phone: "",
      phone_prefix: "+86",
      password: "",
      verify_code: "",
      invite_code: null,
      open_id: null,
      channel_recommend_code: null
    };
    this.weixin = {
      code: null,
      state: -1,
      open_id: null,
      union_id: null,
      refresh_token: null,
      access_token: null
    };
    this.user_id = null;
    this.verify = null;
    this.send_lock = true;
    this.verify_result = {};
    this.register_way = "password";
    this.wechat_loading = false;
    this.wechat_link = null;
    this.nohide = "no-captcha nc-container";
    this.showRegisterDialog = false;
  }
  mounted() {
    return __async(this, null, function* () {
      this.isInWechatMP();
      yield this.ShowPages();
      let lock = localStorage.getItem("register");
      if (lock) {
        this.send_lock = false;
      }
    });
  }
  created() {
    return __async(this, null, function* () {
      let inviteCode = [];
      let cookiesValue = {};
      let register_parameter = null;
      if (Cookies.get("website_search")) {
        cookiesValue = JSON.parse(Cookies.get("website_search"));
      }
      if (Cookies.get("register_parameter")) {
        register_parameter = JSON.parse(
          Cookies.get("register_parameter")
        ).parameter;
      }
      if (window.location.search.length > 0) {
        register_parameter = window.location.search;
      }
      if (Cookies.get("weixin_openid")) {
        this.weixin = JSON.parse(Cookies.get("weixin_openid"));
        this.isWeiXin = true;
      }
      this.formData.query_param = register_parameter;
      if (this.$route.query.hasOwnProperty("c")) {
        inviteCode.push(this.$route.query.c);
      } else if (cookiesValue.hasOwnProperty("c")) {
        inviteCode.push(cookiesValue.c);
      }
      if (this.$route.query.hasOwnProperty("ss")) {
        inviteCode.push(this.$route.query.ss);
      } else if (cookiesValue.hasOwnProperty("ss")) {
        inviteCode.push(cookiesValue.ss);
      }
      if (this.$route.query.hasOwnProperty("t")) {
        inviteCode.push(this.$route.query.t);
      } else if (cookiesValue.hasOwnProperty("t")) {
        inviteCode.push(cookiesValue.t);
      }
      if (this.$route.query.hasOwnProperty("wxcode")) {
        this.wxcode = this.$route.query.wxcode;
      }
      if (this.$route.query.hasOwnProperty("code")) {
        this.weixin.code = this.$route.query.code;
        this.weixin.state = this.$route.query.state;
        const responseGetAccessToken = yield API.get(
          "api://base.app/api/v1/wechat/common/getOpenID?code=" + this.weixin.code
        );
        let weixinToken = responseGetAccessToken.data;
        this.weixin.open_id = weixinToken.access_token.open_id;
        this.weixin.union_id = weixinToken.access_token.union_id;
        this.weixin.access_token = weixinToken.access_token.access_token;
        this.weixin.refresh_token = weixinToken.access_token.refresh_token;
        this.isWeiXin = true;
      }
      this.formData.invite_code = inviteCode.join(";");
    });
  }
  isInWechatMP() {
    const array = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    const userAgent = navigator.userAgent;
    let flag = false;
    for (let i = 0; i < array.length; i++) {
      if (userAgent.indexOf(array[i]) > 0) {
        flag = true;
        break;
      }
    }
    if (navigator.userAgent.match(/miniprogram/i) || //@ts-ignore
    window.__wxjs !== void 0 && //@ts-ignore
    window.__wxjs.environment === "miniprogram" || window.navigator.userAgent.match(/Mobile/i) || flag) {
      this.isWeiXin = true;
      document.getElementsByTagName("body")[0].style.minWidth = "0";
      document.getElementsByTagName("html")[0].style.minWidth = "0";
      document.getElementById("app").style.minWidth = "0";
    } else {
      this.isWeiXin = false;
    }
  }
  ShowPages() {
    return __async(this, null, function* () {
      try {
        this.auth_images = [];
        let response = yield API.get(
          "api://base.app/api/v7_1/account/slide_show",
          {
            params: {
              auth_type: "register"
            }
          }
        );
        this.auth_images = response.data.datas;
      } catch (error) {
        console.log(error);
      }
    });
  }
  sendPhoneCode(lock) {
    return __async(this, null, function* () {
      try {
        let validPhone = true;
        yield this._selfForm.validateField("phone", (errorMessage) => {
          validPhone = errorMessage === "";
        });
        if (validPhone) {
          yield API.post("api://base.app/api/v1/verify_code/send", {
            code_type: 0,
            phone: `${this.formData.phone}`,
            phone_prefix: `${this.formData.phone_prefix}`
          });
          this.$message(
            `${this.$t("register.send_phone_code_tip1")}${this.formData.phone_prefix}-${this.formData.phone}${this.$t("register.send_phone_code_tip2")}`
          );
          this.send_lock = false;
          lock(120);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          if (error.response.data.errors.datas[0].code === "account.virtualphone.register.fail") {
            this.showRegisterDialog = true;
          } else {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
    });
  }
  registerTipBtn() {
    this.showRegisterDialog = false;
  }
  contectToTip() {
    window.open(`https://www.kuajingvs.com/contact`, "_blank");
  }
  toConnection() {
    window.open(`https://www.kuajingvs.com/contact`, "_blank");
  }
  //改变状态时动态重置校验规则
  resetValidate() {
    if (this.formData.phone_prefix === "+86") {
      this.rules.phone[1].validator = Validator.phone;
    } else if (this.formData.phone_prefix === "+1") {
      this.rules.phone[1].validator = Validator.USPhone;
    } else if (this.formData.phone_prefix === "+91") {
      this.rules.phone[1].validator = Validator.IndiaPhone;
    } else if (this.formData.phone_prefix === "+92") {
      this.rules.phone[1].validator = Validator.PakistanPhone;
    }
    this._selfForm.clearValidate();
  }
  setInput(data) {
    console.log(data);
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (yield this._selfForm.validate()) {
          this.status = "submit";
          let _components = yield Fingerprint2.getPromise({
            fonts: { extendedJsFonts: true }
          });
          let _dist = {};
          for (let _item of _components) {
            _dist[_item.key] = _item.value;
          }
          let _speed = [
            _dist["audio"],
            _dist["availableScreenResolution"],
            _dist["colorDepth"],
            _dist["deviceMemory"],
            _dist["hardwareConcurrency"],
            _dist["plugins"],
            _dist["timezone"],
            _dist["userAgent"],
            _dist["canvas"],
            _dist["webgl"],
            _dist["webglVendorAndRenderer"]
          ];
          let _user_id = md5(Base64.encode(_speed.toString()));
          yield API.post(
            "api://base.app/api/v7/register",
            {
              auth_id: this.formData.phone,
              auth_id_prefix: this.formData.phone_prefix,
              captcha: this.formData.verify_code,
              channel_recommend_code: this.wxcode === null ? this.formData.channel_recommend_code : this.wxcode,
              query_param: this.formData.query_param,
              device_mini: _user_id,
              password: this.formData.password,
              platform: "web"
            }
          );
          this.$message.success(this.$t("register.register_success_message"));
          this._phoneVerifyCode.clearLock();
          this.$router.push("/register_discard?regok");
        }
      } catch (error) {
        this.status = "ready";
        if (error.hasOwnProperty("response")) {
          if (error.response.data.errors.datas[0].code === "account.virtualphone.register.fail") {
            this.showRegisterDialog = true;
          } else {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
    });
  }
};
__decorateClass([
  Ref("selfForm")
], Register.prototype, "_selfForm", 2);
__decorateClass([
  Ref("phone_verify_code")
], Register.prototype, "_phoneVerifyCode", 2);
Register = __decorateClass([
  Component({
    components: {
      MainLayout,
      PasswordInput,
      ElPhoneVerifyCodeInput,
      QrcodeVue
    }
  })
], Register);
export {
  Register as default
};
